import { Attributes, Misc, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class FileTypeLookup extends ValueObject {

    public staticFileSpecID: number | null = null;

    public staticServiceProviderFileGroupingID: number | null = null;

    public fileType: string = "All";

    public columnCount: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    public propertiesConcatenated: string = "";

}